import { render, staticRenderFns } from "./subsidiarytypes.vue?vue&type=template&id=63b34769"
import script from "./subsidiarytypes.vue?vue&type=script&lang=js"
export * from "./subsidiarytypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports